"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExcludedTagsProperty = exports.excludedTagsPropertyDefinition = void 0;
exports.excludedTagsPropertyDefinition = {
    view: {
        label: 'Exclude from targeting',
        hint: 'The following tags and content will be excluded from the targeting',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'collection',
                'discipline',
                'playground',
                'story',
            ],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'excluded-tags',
};
const isExcludedTagsProperty = (prop) => {
    return prop.name === exports.excludedTagsPropertyDefinition.name;
};
exports.isExcludedTagsProperty = isExcludedTagsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhjbHVkZWQtdGFncy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2V4Y2x1ZGVkLXRhZ3MucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsd0JBQXdCO1FBQy9CLElBQUksRUFBRSxvRUFBb0U7S0FDM0U7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRTtnQkFDUixZQUFZO2dCQUNaLFlBQVk7Z0JBQ1osWUFBWTtnQkFDWixPQUFPO2FBQ1I7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxlQUFlO0NBQ1UsQ0FBQTtBQUkxQixNQUFNLHNCQUFzQixHQUFHLENBQUMsSUFBa0IsRUFBZ0MsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssc0NBQThCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsc0JBQXNCLDBCQUVsQyJ9